import { AuthService } from "src/app/service/auth.service";
import { Injectable } from "@angular/core";

export interface NavigationItem {
  id: string;
  title: string;
  type: "item" | "collapse" | "group";
  translate?: string;
  icon?: string;
  hidden?: boolean;
  url?: string;
  classes?: string;
  exactMatch?: boolean;
  external?: boolean;
  target?: boolean;
  breadcrumbs?: boolean;
  function?: any;
  badge?: {
    title?: string;
    type?: string;
  };
  children?: Navigation[];
}

export interface Navigation extends NavigationItem {
  children?: NavigationItem[];
}

const NavigationItemsOriginal = [
  {
    id: "navigation",
    title: "Menu",
    type: "group",
    icon: "feather icon-align-left",
    children: [
      {
        id: "home",
        title: "Home",
        type: "item",
        url: "/home",
        classes: "nav-item",
        icon: "feather icon-home",
        perfil: "ADM",
      },
    ],
  },
  {
    id: "navigation",
    title: "Atendimento",
    type: "group",
    icon: "feather icon-align-left",
    children: [
      {
        id: "fila-atendimento",
        title: "Fila Atendimento",
        type: "item",
        url: "/fila-atendimento",
        classes: "nav-item",
        icon: "feather icon-eye",
        perfil: "ADM,ATE",
      },
    ],
  },
  {
    id: "navigation",
    title: "Configurações",
    type: "group",
    icon: "feather icon-align-left",
    children: [
      {
        id: "cadastro-empresa",
        title: "Empresa",
        type: "item",
        url: "/cadastro-empresa",
        classes: "nav-item",
        icon: "feather icon-settings",
        perfil: "ADM",
      },
      {
        id: "cadastro-grupo",
        title: "Grupos",
        type: "item",
        url: "/cadastro-grupo",
        classes: "nav-item",
        icon: "feather icon-grid",
        perfil: "ADM",
      },
      {
        id: "cadastro-atendente",
        title: "Atendentes",
        type: "item",
        url: "/cadastro-atendente",
        classes: "nav-item",
        icon: "feather icon-users",
        perfil: "ADM",
      },
      {
        id: "motivo-encerramento",
        title: "Motivos de Encerramento",
        type: "item",
        url: "/motivo-encerramento",
        classes: "nav-item",
        icon: "feather icon-log-out",
        perfil: "ADM",
      },
    ],
  },
  {
    id: "navigation",
    title: "Contatos",
    type: "group",
    icon: "feather icon-align-left",
    children: [
      {
        id: "contato",
        title: "Contatos",
        type: "item",
        url: "/contato",
        classes: "nav-item",
        icon: "feather icon-phone",
        perfil: "ADM,ATE",
      },
      {
        id: "cadastro-template-modelo",
        title: "Cadastro Template",
        type: "item",
        url: "/cadastro-template-modelo",
        classes: "nav-item",
        icon: "feather icon-plus",
        perfil: "ADM,ATE",
      },
      {
        id: "cadastro-lista",
        title: "Criar Listas",
        type: "item",
        url: "/cadastro-lista",
        classes: "nav-item",
        icon: "feather icon-plus",
        perfil: "ADM,ATE",
      },
      {
        id: "disparar-lista",
        title: "Disparar Lista",
        type: "item",
        url: "/disparar-lista",
        classes: "nav-item",
        icon: "feather icon-message-circle",
        perfil: "ADM,ATE",
      },
      {
        id: "disparo-verificar",
        title: "Verificar Disparos",
        type: "item",
        url: "/disparo-verificar",
        classes: "nav-item",
        icon: "feather icon-list",
        perfil: "ADM,ATE",
      },
    ],
  },
  {
    id: "navigation",
    title: "Fluxo",
    type: "group",
    icon: "feather icon-align-left",
    children: [
      {
        id: "fluxo-draw",
        title: "Montar Fluxo",
        type: "item",
        url: "/fluxo-draw",
        classes: "nav-item",
        icon: "feather icon-share-2",
        perfil: "ADM",
      },
    ],
  },
];

const NavigationItems = [
  {
    id: "navigation",
    title: "Administrativo",
    type: "group",
    icon: "feather icon-align-left",
    children: [
      {
        id: "ficha-paciente",
        title: "Ficha Paciente",
        type: "collapse",
        url: "/ficha-paciente",
        classes: "nav-item",
        icon: "feather icon-user",
        children: [          
          {
            id: "cadastro-usuario",
            title: "Cadastro",
            type: "item",
            url: "/cadastro-usuario",
            classes: "nav-item",
          },
          {
            id: "notificacao",
            title: "Notificacao Receituário",
            type: "item",
            url: "/notificacao",
            classes: "nav-item",
          }
        ]
      },
      {
        id: "docEvidencias",
        title: "Conteúdo",
        type: "collapse",
        icon: "feather icon-file-text",
        children: [          
          {
            id: "Compartilhar Evidências",
            title: "Angiologia",
            type: "collapse",
            url: "/Compartilhar Evidências",
            classes: "nav-item",
            children: [
              {
                id: "artigo",
                title: "Insuficiência Venosa Crônica",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
              {
                id: "artigo",
                title: "Trombose Venosa Profunda",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
            ]
          },
          {
            id: "#",
            title: "Cardiologia",
            type: "collapse",
            url: "/#",
            classes: "nav-item",
            children: [
              {
                id: "artigo",
                title: "Arritmias Cardíacas",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
              {
                id: "artigo",
                title: "Hipertensão Arterial Sistêmica",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
              {
                id: "artigo",
                title: "Insuficiência Cardíaca",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
              {
                id: "artigo",
                title: "Infarto do Miocárdio",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
              {
                id: "artigo",
                title: "Obesidade",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
            ]
          },
          {
            id: "#",
            title: "Dermatologia",
            type: "collapse",
            url: "/#",
            classes: "nav-item",
            children: [
              {
                id: "artigo",
                title: "Acne",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
              {
                id: "artigo",
                title: "Alopecia",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
              {
                id: "artigo",
                title: "Dermatites, Infecções da Pele",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
              {
                id: "artigo",
                title: "Herpes",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
            ]
          },
          {
            id: "#",
            title: "Endocrinologia",
            type: "collapse",
            url: "/#",
            classes: "nav-item",
            children: [
              {
                id: "artigo",
                title: "Diabetes Mellitus",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
              {
                id: "artigo",
                title: "Dislipidemia",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
              {
                id: "artigo",
                title: "Hipoglicemia",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
              {
                id: "artigo",
                title: "Hipotireoidismo, Hipertiroidismo",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
            ]
          },
          {
            id: "#",
            title: "Gastroenterologia",
            type: "collapse",
            url: "/#",
            classes: "nav-item",
            children: [
              {
                id: "artigo",
                title: "Cirrose Hepática",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
              {
                id: "artigo",
                title: "Constipação Intestinal",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
              {
                id: "artigo",
                title: "Diarreia Infecciosa",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
              {
                id: "artigo",
                title: "Doença do Refluxo Gastroesofágico ",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
              {
                id: "artigo",
                title: "Dor abdominal ",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
            ]
          },
          {
            id: "#",
            title: "Geriatria",
            type: "collapse",
            url: "/#",
            classes: "nav-item",
            children: [
              {
                id: "artigo",
                title: "Cuidados Paliativos",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
              {
                id: "artigo",
                title: "Demências",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
              {
                id: "artigo",
                title: "Parkinson",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
              {
                id: "artigo",
                title: "Prevenção de Quedas",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
            ]
          },
          {
            id: "#",
            title: "Ginecologia",
            type: "collapse",
            url: "/#",
            classes: "nav-item",
            children: [
              {
                id: "artigo",
                title: "Corrimento Vaginal",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
              {
                id: "artigo",
                title: "Menopausa",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
              {
                id: "artigo",
                title: "Menstruação",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
              {
                id: "artigo",
                title: "Planejamento Familiar",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              }
            ]
          },
          {
            id: "#",
            title: "Hematóloga",
            type: "collapse",
            url: "/#",
            classes: "nav-item",
            children: [
              {
                id: "artigo",
                title: "Anemia Ferropriva",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              }
            ]
          },
          {
            id: "#",
            title: "Imunóloga",
            type: "collapse",
            url: "/#",
            classes: "nav-item",
            children: [
              {
                id: "artigo",
                title: "Alergia",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              }
            ]
          },
          {
            id: "#",
            title: "Infectologia",
            type: "collapse",
            url: "/#",
            classes: "nav-item",
            children: [
              {
                id: "artigo",
                title: "Dengue, Zyka, Chikungunya",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
              {
                id: "artigo",
                title: "COVID-19",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
              {
                id: "artigo",
                title: "Gripe e Resfriado",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
              {
                id: "artigo",
                title: "Infecções Sexualmente Transmissíveis e sua Exposição ",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
              {
                id: "artigo",
                title: "Infecção de Garganta",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
              {
                id: "artigo",
                title: "Leishmaniose",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
              {
                id: "artigo",
                title: "Monkeypox",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
              {
                id: "artigo",
                title: "Raiva",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
            ]
          },
          {
            id: "#",
            title: "Nefrologia",
            type: "collapse",
            url: "/#",
            classes: "nav-item",
            children: [
              {
                id: "artigo",
                title: "Doença Renal Crônica",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              }
            ]
          },
          {
            id: "#",
            title: "Neurologia",
            type: "collapse",
            url: "/#",
            classes: "nav-item",
            children: [
              {
                id: "artigo",
                title: "AVC",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
              {
                id: "artigo",
                title: "Cefaleia ",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
              {
                id: "artigo",
                title: "Desmaio e Epilepsia",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
              {
                id: "artigo",
                title: "Traumatismo Craniano",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
            ]
          },
          {
            id: "#",
            title: "Obstetrica",
            type: "collapse",
            url: "/#",
            classes: "nav-item",
            children: [
              {
                id: "artigo",
                title: "Pré-Natal",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              }
            ]
          },
          {
            id: "#",
            title: "Odontologia",
            type: "collapse",
            url: "/#",
            classes: "nav-item",
            children: [
              {
                id: "artigo",
                title: "Saúde Bucal",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              }
            ]
          },
          {
            id: "#",
            title: "oftamologia",
            type: "collapse",
            url: "/#",
            classes: "nav-item",
            children: [
              {
                id: "artigo",
                title: "Catarata",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
              {
                id: "artigo",
                title: "Conjuntivite",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
              {
                id: "artigo",
                title: "Glaucoma",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
              {
                id: "artigo",
                title: "Acuidade visual",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
            ]
          },
          {
            id: "#",
            title: "Oncologia",
            type: "collapse",
            url: "/#",
            classes: "nav-item",
            children: [
              {
                id: "artigo",
                title: "Câncer Colorretal",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
              {
                id: "artigo",
                title: "Câncer de Colo do Útero",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
              {
                id: "artigo",
                title: "Câncer de Mama",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
              {
                id: "artigo",
                title: "Câncer de Pele",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
              {
                id: "artigo",
                title: "Câncer de Próstata",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
              {
                id: "artigo",
                title: "Câncer do Estômago",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
              {
                id: "artigo",
                title: "Câncer do Pulmão",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              }
            ]
          },
          {
            id: "#",
            title: "Ortopedia",
            type: "collapse",
            url: "/#",
            classes: "nav-item",
            children: [
              {
                id: "artigo",
                title: "Hérnia de Disco",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
              {
                id: "artigo",
                title: "Lombalgia",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
            ]
          },
          {
            id: "#",
            title: "Otorrinolaringologia",
            type: "collapse",
            url: "/#",
            classes: "nav-item",
            children: [
              {
                id: "artigo",
                title: "Apneia do Sono",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
              {
                id: "artigo",
                title: "Epistaxe",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
              {
                id: "artigo",
                title: "Otite",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
              {
                id: "artigo",
                title: "Sinusite",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
              {
                id: "artigo",
                title: "Vertigem",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              }
            ]
          },
          {
            id: "#",
            title: "Pediatra",
            type: "collapse",
            url: "/#",
            classes: "nav-item",
            children: [
              {
                id: "artigo",
                title: "Amamentação",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
              {
                id: "artigo",
                title: "Cuidados básicos com o recém-nascido",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
              {
                id: "artigo",
                title: "Prevenção de Acidentes",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
              {
                id: "artigo",
                title: "Uso de Telas",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
            ]
          },
          {
            id: "#",
            title: "Pneumologia",
            type: "collapse",
            url: "/#",
            classes: "nav-item",
            children: [
              {
                id: "artigo",
                title: "Asma",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
              {
                id: "artigo",
                title: "DPOC",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
              {
                id: "artigo",
                title: "Pneumonia",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
              {
                id: "artigo",
                title: "Tuberculose",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
            ]
          },
          {
            id: "#",
            title: "Primeiros Socorros",
            type: "collapse",
            url: "/#",
            classes: "nav-item",
            children: [
              {
                id: "artigo",
                title: "Desengasgo e manobra de Heimlich",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
              {
                id: "artigo",
                title: "Ressuscitação Cardiopulmonar (RCP) em adultos e crianças",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              }, 
              {
                id: "artigo",
                title: "Queimaduras",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
            ]
          },
          {
            id: "#",
            title: "Proctologia",
            type: "collapse",
            url: "/#",
            classes: "nav-item",
            children: [
              {
                id: "artigo",
                title: "Hemorroida",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              }
            ]
          },
          {
            id: "#",
            title: "Psiquiatria",
            type: "collapse",
            url: "/#",
            classes: "nav-item",
            children: [
              {
                id: "artigo",
                title: "Ansiedade",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
              {
                id: "artigo",
                title: "Autismo",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
              {
                id: "artigo",
                title: "Depressão",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
              {
                id: "artigo",
                title: "Esquizofrenia",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
              {
                id: "artigo",
                title: "Luto",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
              {
                id: "artigo",
                title: "Suicídio",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
              {
                id: "artigo",
                title: "Transtornos Alimentares",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
              {
                id: "artigo",
                title: "Transtorno do Uso de Substâncias",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
              {
                id: "artigo",
                title: "Transtorno do Déficit de Atenção com Hiperatividade ",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              }
            ]
          },
          {
            id: "#",
            title: "Reumatologia",
            type: "collapse",
            url: "/#",
            classes: "nav-item",
            children: [
              {
                id: "artigo",
                title: "Artrite ",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
              {
                id: "artigo",
                title: "Dor Crônica",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
              {
                id: "artigo",
                title: "Osteoporose",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
            ]
          },
          {
            id: "#",
            title: "Toxicologia",
            type: "collapse",
            url: "/#",
            classes: "nav-item",
            children: [
              {
                id: "artigo",
                title: "Acidente com Animais Peçonhentos",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              }
            ]
          },
          {
            id: "#",
            title: "Urologia",
            type: "collapse",
            url: "/#",
            classes: "nav-item",
            children: [
              {
                id: "artigo",
                title: "ITU ",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
              {
                id: "artigo",
                title: "Nefrolitíase ",
                type: "item",
                url: "/artigo",
                classes: "nav-item",
              },
            ]
          }
        ],
      },
      {
        id: "docEvidencias",
        title: "Jornada",
        type: "collapse",
        icon: "feather icon-file-text",
        children: [
          {
            id: "jornada",
            title: "Alimentação",
            type: "item",
            url: "/jornada",
            classes: "nav-item",
          },
          {
            id: "jornada",
            title: "Atividade Física ",
            type: "item",
            url: "/jornada",
            classes: "nav-item",
          },
          {
            id: "jornada",
            title: "Manejo de Stress ",
            type: "item",
            url: "/jornada",
            classes: "nav-item",
          },
          {
            id: "jornada",
            title: "Conexões Sociais ",
            type: "item",
            url: "/jornada",
            classes: "nav-item",
          },
          {
            id: "jornada",
            title: "Higiene do Sono ",
            type: "item",
            url: "/jornada",
            classes: "nav-item",
          },
          {
            id: "jornada",
            title: "Tabaco ",
            type: "item",
            url: "/jornada",
            classes: "nav-item",
          },
          {
            id: "jornada",
            title: "Álcool  ",
            type: "item",
            url: "/jornada",
            classes: "nav-item",
          },
          {
            id: "jornada",
            title: "Outros Tóxicos  ",
            type: "item",
            url: "/jornada",
            classes: "nav-item",
          },
        ],
      },
    ],
  },
];

@Injectable()
export class NavigationItem {
  constructor(private login: AuthService) {}

  public get(ehTriagem?: boolean) {
    let itens = NavigationItems;
    let comPermissao = [];

    for (var i = 0; i < itens.length; i++) {
      comPermissao.push({ ...itens[i] });
      comPermissao[i].children = [];

      for (var j = 0; j < itens[i].children.length; j++) {
        /*let perfil = this.login.getUser()["user"]["perfil"];

        //retira filhos
        let newArray = itens[i].children[j].perfil.split(",");
        //console.log("split",newArray);

        //if(perfil == itens[i].children[j].perfil){
        if((newArray.find( x => x == perfil)) != undefined){
          comPermissao[i].children.push(itens[i].children[j]);
        }*/
      }
    }

    this.removeReader(comPermissao);

    // anula permissoes remover depois
    comPermissao = itens;

    return comPermissao;
  }

  removeReader(comPermissao: any[]) {
    for (var i = 0; i < comPermissao.length; i++) {
      if (comPermissao[i].children.length == 0) {
        comPermissao.splice(i, 1);
      }
    }
  }

  /*public get(ehTriagem?: boolean) {
    if(ehTriagem)
      return NavigationItems;
  }*/
}
